import React from "react";

function PageFooter({ children }) {
    return <div className="c-page-footer">{children}</div>;
}

export default PageFooter;
